import { Component, OnInit, inject } from '@angular/core';
import {
  UntypedFormGroup,
  FormGroup,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-add-rep',
  templateUrl: './add-rep.component.html',
  styleUrls: ['./add-rep.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class AddRepComponent implements OnInit {
  dialogRef = inject<MatDialogRef<AddRepComponent>>(MatDialogRef);

  repForm: FormGroup;

  constructor() {
    const formGroup = {};
    formGroup['repcode'] = new FormControl();
    formGroup['name'] = new FormControl();
    formGroup['unitid'] = new FormControl();
    this.repForm = new UntypedFormGroup(formGroup);
  }

  unitData = [];

  ngOnInit(): void {}

  save() {
    if (this.repForm.valid) {
      this.dialogRef.close({ data: this.repForm.value });
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
      });
    }
  }

  cancel() {
    this.dialogRef.close();
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }
}
